import modelsResolver from '../utils/modelsResolver';
import { PurchaseHistoryOrder } from './purchaseHistoryOrder';

export interface PurchaseDeviceHistoryResponse {
	_order: any;
	order: PurchaseHistoryOrder[];
}

const model: types.models.InputModel = {
	_order: 'response.Order',
	order: (model: PurchaseDeviceHistoryResponse) => {
		if (model._order) {
			return model._order.map((purchaseHistoryOrder: any) =>
				modelsResolver(purchaseHistoryOrder, 'purchaseHistoryOrder')
			);
		} else {
			return [];
		}
	},
};

export default model;
